import React, { Component } from 'react';
import codePush from 'react-native-code-push';
import { Provider } from 'react-redux';
import configureStore from 'app/core/mobile/configureStore';
import { ApolloProvider } from '@apollo/react-hooks';
import { client } from 'app/core/apollo.client';
import DrawerRouter from './drawerRouter';
import { SafeAreaProvider } from 'react-native-safe-area-context';
import { DripsyProvider } from 'dripsy';
import { theme } from 'styles';
import { ColorModeProvider } from 'styles/ColorMode';

const store = configureStore();
const codePushOptions = {
  checkFrequency: codePush.CheckFrequency.ON_APP_RESUME,
  installMode: codePush.InstallMode.IMMEDIATE,
};

class App extends Component {
  render() {
    return (
      <DripsyProvider theme={theme}>
        <ColorModeProvider>
          <ApolloProvider client={client}>
            <Provider store={store}>
              <SafeAreaProvider>
                <DrawerRouter />
              </SafeAreaProvider>
            </Provider>
          </ApolloProvider>
        </ColorModeProvider>
      </DripsyProvider>
    );
  }
}

export default codePush(codePushOptions)(App);
